import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signup } from '../services/authService';

const SignupButton = () => {
    const [fullName, setFullName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);
    const [showPassword, setShowPassword] = useState(false)
    const navigate = useNavigate(); // Initialize navigate for redirection

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null); // Clear any previous errors

        try {
            // Perform signup and handle response
            const response = await signup({ firstName: fullName, lastName, username: email, password });
            ////console.log("response ", response.ok)
            if (response && response.status === 201) {
                navigate('/login'); // Redirect to login page on success
            } else {
                setError('Signup failed. Please try again.'); // Set error message if signup fails
            }
        } catch (err) {
            setError(err.message || 'Failed to sign up. Please try again.'); // Handle any errors during signup
        }
    };

    return (
        <div className="navFixMargin flex  lg:p-20 lg:px-24 rounded-lg">
            <div className="hidden md:block w-1/2 bg-cover bg-center" style={{ backgroundImage: `url("https://media.licdn.com/dms/image/v2/C5612AQHPI7RWFQuoiw/article-cover_image-shrink_720_1280/article-cover_image-shrink_720_1280/0/1586900654731?e=2147483647&v=beta&t=dWLBmBjd9s9ikFWcAIgfBWIWPbl73_ecbFeaphCZtDs")` }}>
                <div className="flex items-start justify-start p-5 pt-8 h-full bg-black bg-opacity-50 font-poppins">
                    <h1 className="text-white text-2xl">Start Your Journey to Elevate Executive Presence!
                    </h1>
                </div>
            </div>

            {/* Signup Form Section */}
            <div className="w-full md:w-1/2 bg-blue-50 flex items-center justify-center">
                <div className="w-3/4 pb-2 py-4">
                    <h2 className="text-3xl font-bold mb-3 font-poppins">Sign Up</h2>
                    <form onSubmit={handleSubmit}>
                        <div className="mb-4">
                            <label className="block text-gray-700 mb-2" htmlFor="fullName">Full Name</label>
                            <div className="relative">
                                <input
                                    className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
                                    type="text"
                                    id="fullName"
                                    value={fullName}
                                    onChange={(e) => setFullName(e.target.value)}
                                    placeholder="Enter your name"
                                    required
                                />
                                <i className="fas fa-user-circle absolute right-3 top-3 text-gray-400"></i>
                            </div>
                        </div>

                        <div className="mb-4">
                            <label className="block text-gray-700 mb-2" htmlFor="lastName">Last Name</label>
                            <div className="relative">
                                <input
                                    className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
                                    type="text"
                                    id="lastName"
                                    value={lastName}
                                    onChange={(e) => setLastName(e.target.value)}
                                    placeholder="Enter your last name"
                                    required
                                />
                                <i className="fas fa-user-circle absolute right-3 top-3 text-gray-400"></i>
                            </div>
                        </div>

                        <div className="mb-4">
                            <label className="block text-gray-700 mb-2" htmlFor="email">Email</label>
                            <div className="relative">
                                <input
                                    className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
                                    type="email"
                                    id="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Enter your Email"
                                    required
                                />
                                <i className="fas fa-user absolute right-3 top-3 text-gray-400"></i>
                            </div>
                        </div>
                        {/*  */}
                        <div className="mb-4">
                            <label className="block text-gray-700 mb-2" htmlFor="password">
                                Password
                            </label>
                            <div className="relative">
                                <input
                                    className="w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-600"
                                    type={showPassword ? "text" : "password"}
                                    id="password"
                                    value={password}
                                    onChange={(e) => setPassword(e.target.value)}
                                    placeholder="Enter your Password"
                                    required
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="absolute right-3 top-3 text-gray-400 focus:outline-none"
                                >
                                    {showPassword ? (
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="h-5 w-5"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                                            <circle cx="12" cy="12" r="3" />
                                        </svg>
                                    ) : (
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            className="h-5 w-5"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <path d="M13.875 18.825A10.05 10.05 0 0 1 12 19c-7 0-11-7-11-7a15.27 15.27 0 0 1 5.28-5.418M10.61 6.61A10.05 10.05 0 0 1 12 5c7 0 11 7 11 7a15.27 15.27 0 0 1-2.385 2.978" />
                                            <line x1="1" y1="1" x2="23" y2="23" />
                                        </svg>
                                    )}
                                </button>
                            </div>
                        </div>


                        {/*  */}

                        {error && <p className="text-red-500 mb-4">{error}</p>}

                        <button className="w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700" type="submit">Sign Up</button>
                    </form>
                    <div className="flex items-center justify-center gap-3 ">
                        <p className="mt-6 text-center text-gray-600">Already have an Account? <Link to="/login" className="text-blue-600">Login</Link></p>

                        {/* <div className="flex-grow border-t border-gray-300"></div>
                        <span className="mx-4 text-gray-500">Or continue with</span>
                        <div className="flex-grow border-t border-gray-300"></div> */}
                    </div>
                    <div className="flex justify-center items-center">
                        {/* <a href="/auth/google" className="text-gray-600"><i className="fab fa-google fa-2x"></i></a>
                        <a href="/auth/facebook" className="text-gray-600"><i className="fab fa-facebook fa-2x"></i></a>
                        <a href="/auth/instagram" className="text-gray-600"><i className="fab fa-instagram fa-2x"></i></a> */}

                        <p className="text-center font-semibold">Once you sign up, you’ll receive access to our Executive Presence Assessment and a personalized dashboard where you can track your reports.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SignupButton;
